import { countriesOptions } from '@/locale';

export const formFields = {
  address1: {
    label: 'Address line 1',
    id: 'address1',
    type: 'text',
  },
  address2: {
    label: 'Address line 2',
    id: 'address2',
    type: 'text',
  },
  address3: {
    label: 'Address line 3',
    id: 'address3',
    type: 'text',
  },
  town: {
    label: 'Town',
    id: 'town',
    type: 'text',
  },
  postcode: {
    label: 'Postcode',
    id: 'postcode',
    type: 'text',
  },
  country: {
    label: 'Country',
    id: 'country',
    options: countriesOptions,
    type: 'text',
  },
  jobTitle: {
    label: 'Job Title',
    id: 'jobTitle',
    type: 'text',
  },
  organisationName: {
    label: 'Organisation Name',
    id: 'organisationName',
    type: 'text',
  },
};
